import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {
    AngularJsSliderModuleName,
    BranchServiceModuleName,
    CUSTOMER_PROFILE_MODULE_NAME,
    CustomerServiceModuleName,
    CustomersModuleName,
    DragularModuleName,
    DynamicOrderingModuleName,
    EmployeeAutocompleteModuleName,
    FilterComponentsModuleName,
    LoggingModuleName,
    LqbPricerLogModuleName,
    LqbPricerParamsServiceModuleName,
    NAVIGATABLE_MODULE_NAME,
    UserServiceModuleName
} from "../utils/names/optionalModuleNames";
import {NavigationItem} from "../main/model/navigationItem";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";
import {getTabName} from "modules/utils/TabNameUtils";

const template: string = require('./route/Customers.html');

export const CustomersModuleConfiguration = new RestrictedRouteModuleConfiguration(
    CustomersModuleName,
    [
        CustomersModuleName,
        LqbPricerLogModuleName,
        UserServiceModuleName,
        LqbPricerParamsServiceModuleName,
        CustomerServiceModuleName,
        CUSTOMER_PROFILE_MODULE_NAME,
        NAVIGATABLE_MODULE_NAME,
        LoggingModuleName,
        EmployeeAutocompleteModuleName,
        FilterComponentsModuleName,
        BranchServiceModuleName,
        AngularJsSliderModuleName,
        AngularJsMaterialModuleName,
        DynamicOrderingModuleName,
        DragularModuleName
    ],
    [
        ["/customers", {
            template: template,
            controller: 'customerController',
        }],
    ],
    [
        new NavigationItem({
            active: false,
            title: "Customers",
            href: "#!customers",
            activeFunction: routeName =>
                routeName.indexOf("customers") !== -1 ||
                routeName.indexOf("contact_profile") !== -1
        })
    ],
    [CustomersModuleName, CustomerServiceModuleName, CUSTOMER_PROFILE_MODULE_NAME],
    [UserGranredAuthorityName.CUSTOMERS],
    getTabName() + '| Customers'
);

export default CustomersModuleConfiguration;